var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0002 27.3971L9.71226 34.5271C9.11256 34.6573 8.48573 34.5461 7.96736 34.2177C7.44898 33.8892 7.08073 33.3699 6.94226 32.7721L5.59976 27.3971C5.44193 26.7495 5.53156 26.0663 5.8511 25.4813C6.17064 24.8964 6.69706 24.4518 7.32726 24.2346L41.0873 13.1346",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0002 27.3971L9.71226 34.5271C9.11256 34.6573 8.48573 34.5461 7.96736 34.2177C7.44898 33.8892 7.08073 33.3699 6.94226 32.7721L5.59976 27.3971C5.44193 26.7495 5.53156 26.0663 5.8511 25.4813C6.17064 24.8964 6.69706 24.4518 7.32726 24.2346L41.0873 13.1346",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9003 29.3649L44.7303 27.0549",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 52.4986L32.2375 36.9736",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2124 14.849C40.891 13.5627 41.0937 12.2014 41.7758 11.0645C42.4579 9.92764 43.5637 9.10823 44.8499 8.78648L47.5749 8.10648C48.2177 7.94613 48.8978 8.04747 49.4659 8.38825C50.0341 8.72904 50.4437 9.28138 50.6049 9.92398L54.3924 25.074C54.5535 25.7171 54.4525 26.3979 54.1116 26.9666C53.7708 27.5353 53.218 27.9453 52.5749 28.1065L49.8499 28.7865C48.5636 29.1078 47.2023 28.9052 46.0654 28.2231C44.9285 27.5409 44.1091 26.4352 43.7874 25.149L41.2124 14.849Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3958 21.5817L18.1808 32.7217",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 52.4986L27.7626 36.9736",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 37.5006C32.7613 37.5006 34.9999 35.2621 34.9999 32.5006C34.9999 29.7392 32.7613 27.5006 29.9999 27.5006C27.2385 27.5006 24.9999 29.7392 24.9999 32.5006C24.9999 35.2621 27.2385 37.5006 29.9999 37.5006Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.fe7585aa5e6193c6f81b1e3c5b051aad.svg";
export { ForwardRef as ReactComponent };